import { isEmpty } from 'lodash';
import { ValuationsApproach } from 'common/types/valuation';
import { OnChangeType } from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { HandleEquityValueParams } from 'pages/ValuationsAllocation/types';

interface HandleEquityValueHandlerParams {
  params: HandleEquityValueParams;
  approaches: ValuationsApproach[];
  onChange: OnChangeType;
  updateAllocationValues: () => void;
}

/**
 * Handles changes to equity value cells in approach spreadsheets.
 * Updates the corresponding approach's equity value and refreshes allocation values.
 */
export const handleEquityValue = (handlerParams: HandleEquityValueHandlerParams): void => {
  const { params, approaches, onChange, updateAllocationValues } = handlerParams;
  const { cell, expr, customFn } = params;

  const reversed = onChange(cell, expr, customFn);

  reversed
    .filter(reversedApproach => !isEmpty(reversedApproach))
    .forEach(reversedApproach => {
      const updatedApproach = { ...reversedApproach };
      const approachIndex = approaches?.findIndex(
        currentApproach => currentApproach?.panelId === updatedApproach?.panelId
      );

      if (approachIndex !== -1) {
        const updatedApproaches = [...approaches];
        updatedApproach.equity_value = approaches[approachIndex].equity_value;
        updatedApproaches?.splice(approachIndex, 1, updatedApproach);
      }
    });
  updateAllocationValues();
};
